import { FunctionComponent } from 'react';
import { useModal } from '../hooks';
import Modal from '../Modal';
import ModalWrapper from '../mobile-filter/modal-wrapper/modalWrapper';
import { Button } from '~shared/frontend/ui/button/button';
import { t } from 'i18next';
import Clover from './Clover';
// TODO: вынести как отдельный независимый компонент со своими стилями
export const FreeCasesInfoModal: FunctionComponent = () => {
  const modalName = 'FreeCasesInfoModal';
  const { onClose, isOpen } = useModal(modalName);

  return (
    <Modal show={isOpen} onClose={onClose} width={440} modalName={modalName}>
      <ModalWrapper
        isOpen={isOpen}
        onClose={onClose}
        title={t('about_free_cases')}
        titleColor="#FFB800"
      >
        <div className="lucky_modal">
          <p>{String(t('free_cases_info_1'))}</p>
          <p>{String(t('free_cases_info_2'))}</p>
          <p className="lucky_modal_question">
            {String(t('free_cases_info_3'))}
          </p>
          <p>{String(t('free_cases_info_4'))}</p>
          <Button
            text={t('Okay')}
            onClick={onClose}
            className="btn1 btn1_yellow"
          />
        </div>
      </ModalWrapper>
    </Modal>
  );
};
